module.exports = __webpack_public_path__ + "img/virtual.288900d6.jpg";